<h1 class="title-center pb-2" *ngIf="adding">Add Integration Maintenance</h1>
<h1 class="title-center pb-2" *ngIf="!adding">Edit Integration Maintenance</h1>
<h5 class="title-center pb-2" *ngIf="!adding">MaintenanceId: {{maintenance.integrationMaintenanceId}}</h5>
<h5 class="title-center pb-2" *ngIf="!adding">CreatedOn: {{maintenance.createdOn}} | UpdatedOn: {{maintenance.updatedOn}}</h5>

@if(pageLoading){
  <app-lt-spinner></app-lt-spinner>
}
<div class="container">
<div class="row">
  <div class="col-2"></div>
  <div class="col-4 show-selected-div">
    <app-lt-datetimepicker
          class="time-picker"
          placeholder="Enter a date and time"
          label="Start Time:"
          format="MM/dd/yyyy hh:mm:ss a"
          [(value)]="startTimeDateInput">
      </app-lt-datetimepicker>
  </div>
  <div class="col-4 show-selected-div">
    <app-lt-datetimepicker
          class="time-picker"
          placeholder="Enter a date and time"
          label="Stop Time:"
          format="MM/dd/yyyy hh:mm:ss a"
          [(value)]="stopTimeDateInput">
      </app-lt-datetimepicker>
  </div>
  <div class="col-2"></div>
</div>
<br/>
<!-- <div class="row"> -->
<app-dashboard-cards>
  <app-dashboard-filter-card title="Clients">
    <ng-template>
      <app-lt-multiselect-t
        [data]="clients"
        panelWidth=""
        textField="clientDisplayName"
        valueField="clientInformationId"
        placeholder="Select Clients..."
        [(ngModel)]="selectedClients"></app-lt-multiselect-t>
    </ng-template>
  </app-dashboard-filter-card>

  <app-dashboard-filter-card title="Destination Endpoints">
    <ng-template>
      <app-lt-multiselect-t
        [data]="destinationEndpoints"
        panelWidth=""
        textField="displayName"
        valueField="destinationEndpointId"
        placeholder="Select Destination Endpoints..."
        [(ngModel)]="selectedDestinationEndpoints"></app-lt-multiselect-t>
      </ng-template>
  </app-dashboard-filter-card>

  <app-dashboard-filter-card title="Import Types">
    <ng-template>
      <app-lt-multiselect-t
        [data]="importTypes"
        panelWidth=""
        textField="typeDescription"
        valueField="importTypeId"
        placeholder="Select Import Types..."
        [(ngModel)]="selectedImportTypes"></app-lt-multiselect-t>
      </ng-template>
  </app-dashboard-filter-card>

  <app-dashboard-filter-card title="Server">
    <ng-template>
      <app-lt-multiselect-t
        [data]="servers"
        panelWidth=""
        textField="description"
        valueField="serverId"
        placeholder="Select Servers..."
        [(ngModel)]="selectedServers"></app-lt-multiselect-t>
      </ng-template>
  </app-dashboard-filter-card>
</app-dashboard-cards>
<hr class="hr-solid">
<!-- </div> -->

<div class="report-grid-wrapper row">
  <div class="m-1">
    <div class="report-grid-wrapper">

      <div class="report-item-count">
        {{selectedIntegrationIds.length}} Items Selected
      </div>
      <div class="show-selected-div">
        <mat-checkbox #filterCheckbox [(ngModel)]="onlyShowSelectedIntegrations" (change)="loadDataIntoGridView()" [disabled]="selectedIntegrationIds.length === 0">
          <span class="checkbox-text-display">Only display selected</span>
        </mat-checkbox>
      </div>

      <app-lt-png-table #editIntegrationGrid [gridSettingsInput]="integrationGridSettings()" [showToolbarInput]="false" (selectionChange)="selectionChangeHandler()"></app-lt-png-table>
    </div>
  </div>
</div>
<div class="row row-cols-2">
  <div class="show-selected-div col">
    <button id="btnSaveMaintenance"
       matButton="elevated" (click)="saveMaintenance()" [disabled]="savingMaintenance || !startTimeDateInput || !stopTimeDateInput || pastMaintenance ||
      (selectedClients.length === 0 && selectedDestinationEndpoints.length === 0 && selectedImportTypes.length === 0 && selectedServers.length === 0 && selectedIntegrationIds.length === 0)"
      >
      @if (adding)
      {
        Add Maintenance
      }
      @else
      {
        Update Maintenance
      }
    </button>
  </div>
  <div class="show-selected-div col">
    @if (!adding)
    {
      <button id="btnDeleteMaintenance"
        matButton="elevated" (click)="deleteMaintenance()" [primary]="true" [disabled]="savingMaintenance || pastMaintenance"
        title="Delete Maintenance">
        Delete Maintenance
      </button>
    }
  </div>
</div>
</div>